

import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useCatalogContextState } from '../hooks/useCatalogState';

const CatalogContext = createContext();

export const CatalogProvider = ({ children }) => {
    const location = useLocation();
    
    // Extraer pathname y searchParams para el intérprete de URL amigable
    const pathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    
    const catalogState = useCatalogContextState(pathname, searchParams);

    return (
        <CatalogContext.Provider value={catalogState}>
            {children}
        </CatalogContext.Provider>
    );
};

export const useCatalogContext = () => {
    const context = useContext(CatalogContext);
    if (!context) {
        throw new Error('useCatalogContextContext must be used within a CatalogProvider');
    }
    return context;
};
